var _a;
import { UrlMappingsKeys } from '../url-mappings-keys';
export var productPageMapping = (_a = {},
    _a[UrlMappingsKeys.PRODUCT_PAGE] = {
        variables: ['slug'],
        required: ['slug'],
    },
    _a);
//# sourceMappingURL=product-page.js.map